export default {"src":"/_next/static/media/google.7ba31943.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};